<template>
  <div>
    <div class="col-sm-12 col-xl-6">
      <div class="form-card h-100 p-4">
        <h6 class="mb-4">Add Platform</h6>
        <form @submit.prevent="onSubmit">
          <div class="form-floating mb-3">
            <input
              type="text"
              v-model="form.name"
              name="name"
              class="form-control"
              id="name"
              placeholder="Platform Name"
            />
            <label for="name">Name</label>
          </div>
          <div class="form-floating mb-3">
            <input
              type="text"
              v-model="form.username"
              name="username"
              class="form-control"
              id="username"
              placeholder="User Name"
            />
            <label for="username">User Name</label>
          </div>

          <div class="form-floating mb-3">
            <input
              type="text"
              v-model="form.investment"
              name="investment"
              class="form-control"
              id="investment"
              placeholder="Investment"
            />
            <label for="investment">Investment</label>
          </div>

          <div class="form-floating mb-3">
            <input
              type="text"
              v-model="form.profit_loss"
              name="profit_loss"
              class="form-control"
              id="profit_loss"
              placeholder="profit_loss"
            />
            <label for="profit_loss">Profit Loss</label>
          </div>

          <div class="form-floating mb-3">
            <input
              type="text"
              v-model="form.fund"
              name="fund"
              class="form-control"
              id="fund"
              placeholder="Fund"
            />
            <label for="fund">Fund</label>
          </div>
          <div class="form-floating mb-3">
            <button :disabled="v$.form.$invalid" type="submit" @click="addNewPlatform()" class="btn btn-primary">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
    <ReportTable title="Sector" :fields='platformFields' :data ='platformList'/>
  </div>
</template>
  
  <script>
  import useVuelidate from "@vuelidate/core";
  import { required } from "@vuelidate/validators";
  import { useAlertStore } from '@/stores';
  
  import ReportTable from '@/components/Report/Table.ce.vue';
  import { fetchWrapper } from '@/helpers';
  
  export default {
    name: "add-platform",
    components: {
      ReportTable
    },
    setup() {
      return { 
        v$: useVuelidate(),
        alertStore$: useAlertStore(),
       };
    },
    data() {
      return {
        form: {
          name: "",
          username: "",
          investment: "",
          profit_loss: "",
          fund: "",
        },
        platformList: [],
        platformFields: 
        {
          'platform_id' : {
            'text' : 'Platform Id',
            'type' : 'number',
          },
          'name' : {
            'text' : 'Name',
            'type' : 'text', 
          },
          'username' : {
            'text' : 'User Name',
            'type' : 'text', 
          },
          'investment' : {
            'text' : 'Investment',
            'type' : 'currency', 
          },
          'profit_loss' : {
            'text' : 'Profit/Loss',
            'type' : 'currency', 
          },
          'fund' : {
            'text' : 'Fund',
            'type' : 'currency', 
          },
        }
      };
    },
    validations() {
      return {
        form: {
          name: { required },
          username: { required },
        },
      };
    },
    methods: {
      addNewPlatform() {
        try {
          fetchWrapper.post('api/platform/add-new', this.form)
            .then((response) => {
                if(response.success){
                  this.platformList.push(response.data);
                  this.alertStore$.success('New Platform add successfully.');   
                } else {
                  this.alertStore$.error(response.message);
                }
            })
          } catch (error) {
              console.log(error);
          }
      },
      getPlatform(){
        fetchWrapper.post('api/platform')
          .then((response) => {
            this.platformList = response.data;
        })
      },
    },
    mounted() {
      this.getPlatform();
    },
  };
  </script>

<style scoped>
.form-card {
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 12px;
}
</style>